module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1728300141869,
}